// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__19J_i","col":"styles_col__GWCjd"};